import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-close",
  "use": "ico-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-close\">\n<path d=\"M1.63306 12.947L3.0473 14.3613L14.361 3.04756L12.9468 1.63331L1.63306 12.947Z\" fill=\"#3B4153\" />\n<path d=\"M1.63867 3.05298L12.9524 14.3667L14.367 12.9521L3.05325 1.6384L1.63867 3.05298Z\" fill=\"#3B4153\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol